module.exports = __webpack_public_path__ + "static/migration-473c918408e3394036a6bf9cf78e2a5f.png";